import { Stack } from "@mui/material";
import { AdminTransactionFees } from "Components/Dashboard/TransactionFees/AdminTransactionFees";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

export const AdminDashboardPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.Dashboard)}>
      <StyledPageWrapper>
        <Stack gap={2}>
          <AdminTransactionFees variant="currentMonth" />
          <AdminTransactionFees variant="lastMonth" />
          <AdminTransactionFees variant="allTime" />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default AdminDashboardPage;
